import { Collision } from '@dnd-kit/core';
import dayjs from 'dayjs';
import { SnackbarVariant } from '@eas/common-web';
import { CalendarHandle } from '@modules/planner/calendar/calendar-types';
import { bulkPlanWorkOrder } from '@modules/work-order/work-order-api';
import { WorkOrder } from '@models';
import { prepareDto } from '../utils/prepare-dto';

type Props = {
  showSnackbar: (message: string, variant: SnackbarVariant) => void;
  workOrders: WorkOrder[];
  calendarRef: React.RefObject<CalendarHandle>;
  collision: Collision;
};

export const handleBulkPlanWorkOrders = async ({
  showSnackbar,
  workOrders,
  calendarRef,
  collision,
}: Props) => {
  calendarRef?.current?.setBulkPlanningloading?.(true);
  const dto = prepareDto({
    currentDate: calendarRef.current?.currentDate ?? 0,
    collision,
    workOrder: workOrders[0],
    offset: 0,
  });

  const response = (await bulkPlanWorkOrder({
    date: dayjs(dto.plannedFrom).format('YYYY-MM-DD'),
    ownerId: dto.unitId,
    ownerType: dto.unitType,
    ids: workOrders.map((w) => w.id) ?? [],
  }).json()) as { id: string; success: boolean }[];

  const failed = response
    .filter((r) => !r.success)
    .map((f) => ({
      wid: workOrders.find((w) => w.id === f.id)?.workOrderId ?? '',
    }));

  if (failed.length > 0) {
    showSnackbar(
      `Niektoré prac. príkazy sa nepodarilo naplánovať. Skontrolujte ich stav: ${failed
        .map((f) => f.wid)
        .join(', ')}
            `,
      SnackbarVariant.WARNING
    );
  }
  calendarRef?.current?.setBulkPlanningloading?.(false);
  return true;
};
